<template>
  <v-form ref="customFieldForm" v-model="formValid" lazy-validation>
    <v-layout wrap>
      <v-flex xs12 px-2>
        <v-text-field
          v-model="selectedCustomField.name"
          label="Veldnaam"
          :rules="[formRules.name]"
          required
        ></v-text-field>
      </v-flex>
      <v-flex xs12 px-2>
        <v-select
          :items="customFieldTypes"
          :disabled="selectedCustomField.id ? true : false"
		  item-value="id"
          item-text="name"          
          label="Formulier type"
          v-model="selectedCustomField.customFieldTypeId"
          :rules="[formRules.customFieldType]"
          required
        ></v-select>
      </v-flex>	  
<!--- CHECKBOX  -->
      <v-flex v-if="currentSelectedType=='checkbox'" xs12 px-2 d-flex>
        <v-flex md6 xs12 pl-4 pr-4>
            <v-text-field                
                v-model="checkboxPredefinedFields[0].value"
                label="tekst checkbox leeg"
                :rules="[formRules.checkboxUnchecked]"
                required
            ></v-text-field>                    
        </v-flex>          
        <v-flex md6 xs12 pl-4 pr-4>
            <v-text-field                            
                v-model="checkboxPredefinedFields[1].value"
                label="Tekst checkbox aangevinkt"
                :rules="[formRules.checkboxChecked]"
                required
            ></v-text-field>            
        </v-flex>
      </v-flex> 
<!--- SELECT  -->
      <v-flex xs12 v-if="currentSelectedType=='select'" >
            <v-flex pl-4 pr-8 xs12 md6 v-for="(item,index) in dropdownPredefinedFields" :key="index">
                <v-flex d-flex align-center>
                    <v-text-field 
                        v-model="dropdownPredefinedFields[index].value"
                        :rules="[formRules.dropDown]"                        
                        label="Selectie optie"
                        required
                    ></v-text-field>                    
                    <i  v-if="dropdownPredefinedFields.length == index+1" @click="addDropdownField()" style="color:green; cursor:pointer;" class="fas fa-plus"></i>
                    <i @click="removeSelectOption(index)" style="color:red; cursor:pointer;" class="fas fa-times"></i>                                    
                </v-flex>
            </v-flex>  
      </v-flex>
<!--- NUMBERRANGE  -->
      <v-flex xs12 v-if="currentSelectedType=='numeric_range'" d-flex>
        <v-flex md6 xs12 pl-4 pr-4>
            <v-text-field
            pl-4 
            v-model="rangePredefinedFields[0].value"
            label="Start bij getal"
            mask="#######"
            :rules="[formRules.numberRangeStartNumber]"
            required
            ></v-text-field>
        </v-flex>
        <v-flex md6 xs12 pl-4 pr-4>
            <v-text-field
            pl-4 
            v-model="rangePredefinedFields[1].value"
            label="Eindig bij getal"
            mask="############"
            :rules="[formRules.numberRangeEndNumber]"            
            required
            ></v-text-field>        
        </v-flex>
      </v-flex>
      <v-flex row xs12 wrap mt-4>
        <v-layout>
          <v-btn @click="cancel" color>Annuleren</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="save">Opslaan</v-btn>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-form>
</template>
<script>
import * as types from "../../store/types"
import { mapGetters } from "vuex"
export default {
    data() {
        return {
            formValid:true,
            validateCustomFields:false,
            dropdownPredefinedFields:[
                {key:"", value:""},
                {key:"", value:""}
            ],
            checkboxPredefinedFields:[
                {key:"", value:""},
                {key:"", value:""}
            ],
            rangePredefinedFields:[
                {key:"", value:""},
                {key:"", value:""}
            ],
            formRules:{
                name:(value) => {return (value) ? true : "Veld verplicht"},           
                customFieldType:(value) => {return (value) ? true : "Veld verplicht"}, 
                checkboxChecked:(value) => {return (value) ? true : "Veld verplicht"},               
                checkboxUnchecked:(value) => {return (value) ? true : "Veld verplicht"}, 
                dropDown:(value) => {
                    let errorText = "Veld verplicht, minimaal 2 opties en uniek"
                    if(!this.validateCustomFields){
                        return true                
                    }    
                    let counter = 0
                    this.dropdownPredefinedFields.forEach((item,index) => {
                        if(item.value == value){
                            counter++
                        }
                    })
                    if(counter>1)
                        return errorText
                    return (value && this.dropdownPredefinedFields.length > 1 ) ? true : errorText
                },                                 
                numberRangeStartNumber:(value) => {
                    if(!this.validateCustomFields)
                        return true
                    let errorText = "Veld verplicht en getal moet lager zijn dan eind getal"
                    return (value && this.numberRangeEndNumber) && (parseInt(value) < parseInt(this.numberRangeEndNumber)) ? true : errorText                    
                },
                numberRangeEndNumber:(value) => {
                    if(!this.validateCustomFields)
                        return true                                            
                    let errorText = "Veld verplicht en getal moet lager zijn dan eind getal"
                    return (value && this.numberRangeStartNumber) && (parseInt(value) > parseInt(this.numberRangeStartNumber)) ? true : errorText
                }
            },
            selectedCustomField: {
                id:"",
                name:"",
                internalName:"",
                customFieldTypeId:"",                    
                allowedValues:[],
            }
        }
    },
    computed: {
        ...mapGetters({
            customFieldTypes: types.CUSTOM_FIELD_TYPES            
        }),
        currentSelectedType(){         
            let obj = this.customFieldTypes.find(o => o.id === this.selectedCustomField.customFieldTypeId )
            return  obj ? obj.internalName : null 
        },
        currentSelectedTypeObject(){
            let obj = this.customFieldTypes.find(o => o.id === this.selectedCustomField.customFieldTypeId )
            return  obj ? obj : null             
        },
        numberRangeStartNumber(){
            return this.rangePredefinedFields[0].value
        },
        numberRangeEndNumber(){
            return this.rangePredefinedFields[1].value
        }     
    },        
    props:{
        customField:{
            type: Object
        },
        newOnSave:{
            
        }
    },
    methods: {
        save() {
            this.validateCustomFields=true
            if (this.$refs.customFieldForm.validate()) {                
                let save = this.prepareSaveObject()
                this.$store.dispatch(types.SAVE_CUSTOM_FIELD, { data: save }).then(e => {
                    this.selectedCustomField.id = e.id
                    this.saveCustomFieldAllowedValues()                    

                    if(this.newOnSave == 1){
                        this.clearForm();
                    }

                    this.$emit('saved',e)
                })              
            } 
            this.validateCustomFields=false
        },
        addDropdownField(){
            this.dropdownPredefinedFields.push({key:"", value:""})
        },
        saveCustomFieldAllowedValues(){            
            if(this.currentSelectedTypeObject.requiresAllowedValues){
                let arr = []
                if(this.currentSelectedType == "select"){
                    arr = this.dropdownPredefinedFields
                }
                if(this.currentSelectedType == "checkbox"){
                    arr = this.checkboxPredefinedFields
                }                
                if(this.currentSelectedType == "numeric_range"){
                    arr = this.rangePredefinedFields
                }

                
                arr.forEach((obj) =>{
                    obj.custom_field_id = this.selectedCustomField.id
                    
                    this.$store.dispatch(types.SAVE_CUSTOM_FIELD_ALLOWED_VALUE, { data: obj }).then(f => {
                        
                    })
                })                   
            }             
        },
        prepareSaveObject(){            
            let save = {}
            save.name = this.selectedCustomField.name

            // if id is known add it for save
            if(this.selectedCustomField.id){
                save.id   = this.selectedCustomField.id                             
            }
            else{ // add field type id (can only be added on create NEVER changed on update)
                save.customFieldTypeId = this.selectedCustomField.customFieldTypeId
            }                                
            return save                        
        },
        removeSelectOption(index){
            let newArr = []
            for(let i in this.dropdownPredefinedFields){
                if(i == index){
                    if(this.dropdownPredefinedFields[i].key){
                        this.removeCustomFieldAllowedValue(this.dropdownPredefinedFields[i].key)
                    }
                }
                else{
                    newArr.push(this.dropdownPredefinedFields[i])
                }
            }
            this.dropdownPredefinedFields = newArr
        },
        removeCustomFieldAllowedValue(deleteKey){
            let obj = {key:deleteKey, custom_field_id:this.selectedCustomField.id}

            this.$store.dispatch(types.DELETE_CUSTOM_FIELD_ALLOWED_VALUE, { data: obj }).then(f => {

            })            
        },        
        prepareComplexTypes(){

            if(this.selectedCustomField.allowedValues && this.selectedCustomField.allowedValues.length > 0){    
                
                if(this.selectedCustomField.type.internalName == "select"){                    
                    this.dropdownPredefinedFields = this.selectedCustomField.allowedValues                    
                }                         
                if(this.selectedCustomField.type.internalName == "checkbox"){
                    this.checkboxPredefinedFields = this.selectedCustomField.allowedValues
                }
                if(this.selectedCustomField.type.internalName == "numeric_range"){
                    this.rangePredefinedFields = this.selectedCustomField.allowedValues                    
                }
            }
        },
        cancel(){
            this.$emit("cancelClicked")
        },
        clearForm(){
           this.selectedCustomField = {
                id:"",
                name:"",
                internalName:"",
                customFieldTypeId:"",                    
                allowedValues:[]
            }
            this.dropdownPredefinedFields = [
                {key:"", value:""},
                {key:"", value:""}
            ]
            this.checkboxPredefinedFields = [
                {key:"", value:""},
                {key:"", value:""}
            ]
            this.rangePredefinedFields = [
                {key:"", value:""},
                {key:"", value:""}
            ]
        }
    },
    mounted(){
        if(this.customFieldTypes.length==0){
            this.$store.dispatch(types.CUSTOM_FIELD_TYPES,{})                              
        }
        if (this.customField) {
            // use Object.assign to remove reference to prop
            Object.assign(this.selectedCustomField, this.customField)	

            this.prepareComplexTypes(this.selectedCustomField)
        }    
    }
}
</script>

<style scoped>

</style>